<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0 z-0">
      <b-card-header id="etrp-card-header" class="pl-2 pr-3 small">
        <!-- {{ $moment().diff($moment(sabrepnr.timestamp,'DD/MM/YYYY HH:mm:SS'), 'minutes') }} -->
        ETRP ( {{ tile.settings.find((o) => o.key == "server").value }} )
        <div class="card-header-actions">
          {{ etrp.timestamp }}
          <span
            id="etrp_ago"
            :class="'ml-2 status-dot ' + lastrunstatus"
            pulse="true"
          ></span>
        </div>
      </b-card-header>
      <b-tooltip target="etrp-card-header" triggers="hover"
        >ETRP is the Electronic Ticket Receipt Processor. It monitors incoming
        tickets and performs actions, like invoicing and refunds. You can
        monitor actions, commands and also start and stop the
        processing.</b-tooltip
      >
      <!-- <b-tooltip
        target="sabrepnr-card-header"
        triggers="hover"
      >Navitas Robotic checking the Sabre 499 queue</b-tooltip>
      -->
      <b-tooltip target="etrp_ago" triggers="hover">{{
        $moment(etrp.timestamp, "DD/MM/YYYY HH:mm:SS") | formatTimeago
      }}</b-tooltip>
      <b-card-body class="px-0 pt-0">
        <b-table
          v-if="etrp.showtable"
          ref="logtable"
          id="logtable"
          striped
          sticky-header="205px"
          fixed
          small
          bordered
          :items="items"
          :fields="etrp.fields"
          class="gridtable my-0"
        ></b-table>
        <b-row class="excelsheetbuttons">
          <b-col>
            <b-button-group>
              <b-button
                :pressed="true"
                squared
                size="sm"
                variant="outline-secondary"
                id="etrp_log"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="etrp_log" triggers="hover">Show log</b-tooltip>
            </b-button-group>
          </b-col>
          <!--   <b-col>
            <b-button-group>
              <b-link size="sm" squared :pressed="true" variant="outline-danger" >
                <i class="fa fa-stop text-danger"></i>
              </b-link>
              <b-link size="sm" squared variant="outline-success" class="ml-1">
                <i class="fa fa-play"></i>
              </b-link>
            </b-button-group>
          </b-col>-->
          <b-col class="text-right">
            <!--    <b-button
                variant="outline-primary"
                :pressed="sabrepnr.format=='grid'"
                @click="outputSwitch()"
                title="Send to screen"
              >
                <i class="fa fa-desktop" aria-hidden="true"></i>
            </b-button>-->

            <b-tooltip target="etrp-excel" triggers="hover"
              >Grid to excel</b-tooltip
            >
            <b-link id="etrp-start" disabled size="sm" class="mt-1 mr-2">
              <i class="fa fa-play"></i>
            </b-link>
            <b-tooltip target="etrp-start" triggers="hover"
              >Start service</b-tooltip
            >

            <b-link id="etrp-end" disabled size="sm" class="mt-1 mr-2">
              <i class="fa fa-stop"></i>
            </b-link>
            <b-tooltip target="etrp-end" triggers="hover"
              >Service is stopped</b-tooltip
            >
            <b-link
              id="etrp-excel"
              class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })"
              title="Grid to excel"
            >
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <!--   <b-link
                class="mt-1"
                squared
                size="sm"
                variant="outline-primary"
                title="Expand/collapse"
                @click="etrp.showtable=!etrp.showtable"
              >
                <i v-if="etrp.showtable" class="fa fa-arrow-up"></i>
                <i v-if="!etrp.showtable" class="fa fa-arrow-down"></i>
            </b-link>-->
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary"
              >Showing {{ etrp.items.length }} message(s)</span
            >
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "ETRPStatus",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "ETRPStatus",
      etrp: {
        // lastrunstatus: "success",
        timestamp: "Unknown",
        status: "negative",
        showtable: true,
        format: "grid",
        fields: [
          {
            key: "action_at",
            label: "Date and Time",
            sortable: true,
            sortDirection: "desc",
            class: "w-30pct",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "action",
            label: "Action",
            sortable: true,
            sortDirection: "desc",
            class: "w-75pct",
          },
        ],
        items: [],
      },
    };
  },
  async mounted() {
    this.$helpers.resizableColumns();
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    items() {
      return this.etrp.items;
    },
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
    lastrunstatus() {
      let result = "danger";
      if (this.etrp.timestamp != "Unknown") {
        let minutes = this.$moment().diff(
          this.$moment(this.etrp.timestamp, "DD/MM/YYYY HH:mm:SS"),
          "minutes"
        );
        if (minutes <= 5) {
          result = "success";
        } else if (minutes > 5 && minutes < 60) {
          result = "warning";
        } else {
          result = "danger";
        }
      }
      return result;
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: ETRPStatus");

      this.busy = true;

      let variables = {};
      variables.id = "etrp_log";
      try {
        const response = await this.$apollo.query({
          query: gql`
            query file_date($id: String) {
              file_date(id: $id)
            }
          `,
          variables,
        });
        console.log("etrp log is", response);
        if (response.data.file_date) {
          this.etrp.timestamp = this.$moment
            .unix(response.data.file_date / 1000)
            .format("DD/MM/YYYY HH:mm:SS");
        }
      } catch (error) {
        console.log(error);
      }

      variables = {};
      try {
        const response = await this.$apollo.query({
          query: gql`
            query etrp_actions {
              etrp_actions {
                id
                action
                action_at
              }
            }
          `,
          variables,
        });
        this.etrp.items = response.data.etrp_actions;
      } catch (error) {
        console.log(error);
      }
      this.busy = false;

      this.busy = false;
      await this.$emit("refreshed");
    },

    async action(e) {
      console.log("action", e.key);
      switch (e.key) {
        case "refresh":
          await this.loadChart();
          break;
      }
    },
  },
};
</script>


<style>
</style>